import { createAction, props } from '@ngrx/store';

export const loadCurrencyRate = createAction('[Currency Rate] Load', props<{ code: string }>());
export const loadCurrencyRateSuccess = createAction('[Currency Rate] Load Currency Success', props<{ rate: number }>());
export const loadCurrencyRateFail = createAction('[Currency Rate] Load Fail', props<{ error: unknown }>());
